<template>
<div class="mb-3">
  <div v-if="loading">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <div v-if="!loading">
    <div class="table-caption">{{ tableCaption }}</div>
    <VuePerfectScrollbar class="objetives-table-holder" >
    <b-table sort-by="label" responsive stacked="sm" :fields="fields" :items="items" :per-page="perPage" :current-page="currentPage">
      <template v-slot:cell(label)="data" >
        <i :class="'fa fa-thumbs-up text-'+data.item.variant" v-if="data.item.variant == 'success'"></i>
        <i :class="'fa fa-thumbs-down text-'+data.item.variant" v-if="data.item.variant != 'success'"></i> {{ data.item.label }}
      </template>
      <template  v-slot:cell(objective)="data">
        {{ Math.round(data.item.objective) | currency({fractionCount:0, symbol:symbol}) }}
      </template>
      <template v-slot:cell(total)="data">
        {{ Math.round(data.item.total) | currency({fractionCount:0, symbol:symbol}) }}
      </template>
      <template v-slot:cell(progress)="data">
        {{ data.item.progress | currency({fractionCount:1, symbol:'%'}) }}
      </template>
      <template v-slot:cell(remaining)="data">
        {{ data.item.remaining | currency({fractionCount:0, symbol:''}) }}
      </template>
      <template v-slot:cell(balance)="data">
        {{  Math.round(data.item.objective - data.item.total)  | currency({fractionCount:0, symbol:''}) }}
      </template>
    </b-table>
    </VuePerfectScrollbar>
    <b-pagination v-show="items.length>perPage && perPage>0" :total-rows="items.length" :per-page="perPage" v-model="totalPage" class="justify-content-center" />
  </div>
</div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  props: ['items', 'loading', 'fields', 'table-caption', 'symbol', 'per-page', 'show-remaining'],
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      totalPage: 1,
      currentPage: null
    }
  },
  methods: {},
  created() {
    console.log('Remaining:', this.showRemaining)
  }
}
</script>



// WEBPACK FOOTER //
// ObjectivesTable.vue?6fb06c73